/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Rias_TitleInputs */

const es_marketplace_seo_galicia_guide_rias_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Rias_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegar las Rías Baixas`)
};

const gl_marketplace_seo_galicia_guide_rias_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Rias_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegar as Rías Baixas`)
};

const en_marketplace_seo_galicia_guide_rias_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Rias_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sailing the Rías Baixas`)
};

/**
* | output |
* | --- |
* | "Sailing the Rías Baixas" |
*
* @param {Marketplace_Seo_Galicia_Guide_Rias_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_rias_title = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Rias_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Rias_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_rias_title(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_rias_title(inputs)
	return es_marketplace_seo_galicia_guide_rias_title(inputs)
});